const t = type => `intl/${type}`

export const SET_CURRENT_LOCALE = t('SET_CURRENT_LOCALE')
